<app-layout-container>
  <section class="services-hero">
    <app-section-heading [animateTitle]="true"
                         animateTitleTrigger="in-view"
                         eyebrow="Services"
                         title="Guaranteed Engaging Experience and support built for modern teams"
                         text="United Team Building provides fun and team building experiences in any profession or industry. Team members participate in small groups, using a podium for a challenging competitive ">
    </app-section-heading>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="services-industries" aria-label="Industries served">
    <div class="services-industries__grid">
      @for (industry of industryHighlights; track industry.title) {
      <article class="services-industries__item">
        <span class="services-industries__icon" aria-hidden="true">
          @switch (industry.title) {
          @case ('Medical') {
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <rect x="8" y="12" width="48" height="44" rx="10" fill="var(--color-accent)" />
            <rect x="13" y="24" width="38" height="27" rx="6" fill="var(--color-surface-1)" />
            <rect x="29" y="30" width="6" height="16" rx="2" fill="var(--color-text)" />
            <rect x="24" y="35" width="16" height="6" rx="2" fill="var(--color-text)" />
            <path d="M22 25h20" stroke="var(--color-text)" stroke-width="3" stroke-linecap="round" />
            <rect x="18" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
            <rect x="42" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
          </svg>
          }
          @case ('Office') {
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <rect x="8" y="12" width="48" height="44" rx="10" fill="var(--color-accent)" />
            <rect x="13" y="24" width="38" height="27" rx="6" fill="var(--color-surface-1)" />
            <rect x="20" y="30" width="24" height="12" rx="2" fill="none" stroke="var(--color-text)" stroke-width="3" />
            <path d="M32 42v4M25 46h14" stroke="var(--color-text)" stroke-width="3" stroke-linecap="round" />
            <rect x="24" y="34" width="5" height="4" rx="1" fill="var(--color-text)" />
            <rect x="18" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
            <rect x="42" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
          </svg>
          }
          @case ('University') {
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <rect x="8" y="12" width="48" height="44" rx="10" fill="var(--color-accent)" />
            <rect x="13" y="24" width="38" height="27" rx="6" fill="var(--color-surface-1)" />
            <path d="M18 32l14-6 14 6-14 6z" fill="var(--color-text)" />
            <path d="M24 36v5c0 2 3.5 4 8 4s8-2 8-4v-5" stroke="var(--color-text)" stroke-width="3" fill="none" stroke-linecap="round" />
            <path d="M46 33v7" stroke="var(--color-text)" stroke-width="3" stroke-linecap="round" />
            <rect x="18" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
            <rect x="42" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
          </svg>
          }
          @case ('Professional') {
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <rect x="8" y="12" width="48" height="44" rx="10" fill="var(--color-accent)" />
            <rect x="13" y="24" width="38" height="27" rx="6" fill="var(--color-surface-1)" />
            <rect x="20" y="31" width="24" height="14" rx="2" fill="none" stroke="var(--color-text)" stroke-width="3" />
            <path d="M28 31v-3h8v3" stroke="var(--color-text)" stroke-width="3" stroke-linecap="round" />
            <path d="M28 38h8" stroke="var(--color-text)" stroke-width="3" stroke-linecap="round" />
            <rect x="18" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
            <rect x="42" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
          </svg>
          }
          @default {
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <rect x="8" y="12" width="48" height="44" rx="10" fill="var(--color-accent)" />
            <rect x="13" y="24" width="38" height="27" rx="6" fill="var(--color-surface-1)" />
            <path d="M20 45V34l8 4v-4l8 4v-7h8v14z" fill="var(--color-text)" />
            <rect x="40" y="25" width="4" height="8" rx="1" fill="var(--color-text)" />
            <circle cx="30" cy="40" r="1.5" fill="var(--color-surface-1)" />
            <circle cx="35" cy="40" r="1.5" fill="var(--color-surface-1)" />
            <rect x="18" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
            <rect x="42" y="8" width="4" height="10" rx="2" fill="var(--color-accent)" />
          </svg>
          }
          }
        </span>
        <h3 class="services-industries__title">{{ industry.title }}</h3>
      </article>
      }
    </div>
  </section>
</app-layout-container>



<app-layout-container>
  <section class="services-media-pilot" aria-label="Service media highlights">
    <app-section-heading [animateTitle]="true"
                         animateTitleTrigger="in-view"
                         eyebrow="How it Works"
                         title="The Highlights"
                         text="View some of the highlights of our team building experience.">
    </app-section-heading>

    <div class="services-media-pilot__grid">
      <div class="services-media-pilot__video-column">
        <video class="services-media-pilot__video"
               muted
               loop
               autoplay
               playsinline
               preload="metadata"
               aria-label="How it Works demonstration video">
          <source [src]="howItWorksVideoUrl" type="video/webm">
        </video>
      </div>

      <div class="services-media-pilot__content-column">
        <ul class="services-media-pilot__list">
          @for (highlight of howItWorksHighlights; track highlight) {
          <li class="services-media-pilot__list-item flex items-start gap-3">
            <span
              class="mt-[0.55em] inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-gradient-to-br from-[var(--color-accent-soft)] via-[var(--color-accent)] to-[var(--color-text)] ring-2 ring-[color-mix(in_srgb,var(--color-accent)_24%,transparent)]"
              aria-hidden="true">
            </span>
            <span>{{ highlight }}</span>
          </li>
          }
        </ul>
      </div>
    </div>
  </section>
</app-layout-container>

<section id="how-to-get-started" class="services-band">
  <app-layout-container>
    <div class="services-band__inner">
      <app-section-heading [animateTitle]="true"
                           animateTitleTrigger="in-view"
                           eyebrow="How to get started"
                           title="A clear process from start to finish."
                           text="A summary of the steps are below. Slide to see the steps and click on any topic for details.">
      </app-section-heading>

      <app-card-slider class="services-band__slider" [cards]="processSteps"></app-card-slider>
    </div>
  </app-layout-container>
</section>
<app-layout-container>
  <section class="services-grid-section">
    <div class="services-grid">
      @for (service of serviceCards; track service.title) {
      <article class="service-card">
        <h3 class="service-card__title">{{ service.title }}</h3>
        <p class="service-card__text">{{ service.text }}</p>
      </article>
      }
    </div>
  </section>
</app-layout-container>
<app-layout-container>
  <section class="services-cta">
    <div class="services-cta__panel">
      <div>
        <app-section-heading [animateTitle]="true"
                             animateTitleTrigger="in-view"
                             eyebrow="Next step"
                             title="Ready to talk about your team?"
                             text="Tell us what you’re planning and we’ll help shape the right experience.">
        </app-section-heading>
      </div>

      <div class="services-cta__actions">
        <a class="button button--primary" routerLink="/contact-us">Contact Us</a>
        <a class="button button--secondary" routerLink="/testimonials">View Testimonials</a>
      </div>
    </div>
  </section>
</app-layout-container>
